module.exports = __webpack_public_path__ + "static/icons/icon-accommodation-9a6bf0b73d922874c3760ff2b5d815e5.svg";